import React from 'react';
import { compose, lifecycle, withProps, withHandlers } from 'recompose';

import { AnimatedRain as AR } from './AnimatedRain';

const enhance = compose(
  withProps(() => ({
    dropRef: React.createRef(),
    canvasRef: React.createRef(),
  })),
  withHandlers(() => ({
    startAnimation: ({ dropRef, canvasRef, width, height, density }) => () => {
      const drawRain = () => {
        requestAnimationFrame(drawRain);

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        if (Math.random() < density) {
          drops.push({
            x: (Math.random() * canvas.width) | 0,
            y: -50,
            dy: 3,
            s: 0.5 + Math.random(),
            state: (Math.random() * 100) | 0,
          });
        }

        let i = drops.length;

        while (i) {
          i = i - 1;
          drops[i].state = drops[i].state > 9 ? 0 : drops[i].state + 0.1;
          drops[i].dy += 0.3;
          drops[i].y += drops[i].dy;

          ctx.drawImage(
            drop,
            44 * Math.floor(drops[i].state),
            0,
            44,
            40,
            drops[i].x,
            drops[i].y,
            44 * drops[i].s,
            40 * drops[i].s,
          );

          if (drops[i].y > canvas.height) {
            drops.splice(i, 1);
          }
        }
      };

      const drop = dropRef.current;
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');
      const drops = [];

      canvas.width = width || canvas.parentElement.clientWidth;
      canvas.height = height || canvas.parentElement.clientHeight;

      drop.addEventListener('load', drawRain);
    },
  })),
  lifecycle({
    componentDidMount() {
      this.props.startAnimation();
    },
  }),
);

export const AnimatedRain = enhance(AR);

export default AnimatedRain;

AnimatedRain.defaultProps = {
  density: 0.3,
};
